/* eslint-disable jsx-a11y/accessible-emoji */
import React from "react";
import job1 from "../assets/jabas/jaba-1.jpg";
import job2 from "../assets/jabas/jaba-2.jpg";
import job3 from "../assets/jabas/jaba-3.jpg";
import gitLogo from "../assets/stack/github.png";

const Portfolio = (props) => {
  return (
    <div className="developer-right">
      <div className="back-home">
        <button className="sprite invert">Home</button>
      </div>
      <div className="rocket invert">
        <h2 title="Do you want to talk?">Want to talk?</h2>
        <h3>
          <a
            href="https://www.linkedin.com/in/diegotauchert/"
            target="_blank"
            rel="noopener noreferrer"
            title="See my linkedin"
          >
            Send me a Cute Message 👽
          </a>
        </h3>
      </div>

      <div className="github invert">
        <h2>
          <a
            href="https://github.com/diegotauchert"
            target="_blank"
            rel="noopener noreferrer"
            title="See my linkedin"
          >
            <img src={gitLogo} alt="GitHub" className="black-img" width="30" />
            <strong>
              <span>My Repos</span>
              Github
            </strong>
          </a>
        </h2>
      </div>

      <div className="jobs">
        <h2 title="My Recents Cases">My Recents Cases</h2>

        <button className="nav-job next">
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="57.000000pt"
            height="61.000000pt"
            viewBox="0 0 57.000000 61.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0.000000,61.000000) scale(0.100000,-0.100000)"
              fill={props.fill}
              stroke="none"
            >
              <path d="M224 555 c-4 -9 -1 -43 5 -76 7 -34 11 -62 9 -63 -2 -2 -49 -16 -106 -32 -115 -33 -112 -28 -85 -124 14 -50 22 -64 56 -86 l40 -26 66 20 c36 11 74 23 84 27 14 6 20 1 30 -24 6 -17 18 -33 27 -35 61 -16 66 -16 83 13 9 15 37 53 62 84 l46 55 -20 39 c-30 58 -58 85 -158 157 -122 86 -132 91 -139 71z m159 -113 c48 -35 87 -67 87 -71 0 -12 -91 -166 -109 -184 -18 -18 -19 -18 -30 30 -19 79 -15 78 -132 43 -57 -17 -108 -28 -115 -26 -6 2 -15 21 -18 41 -4 20 -9 42 -12 49 -4 11 106 53 187 72 l27 6 -14 51 c-8 29 -14 60 -14 70 0 17 1 17 28 0 15 -10 66 -46 115 -81z m-106 -224 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-90 -20 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z" />
              <path d="M240 120 c-10 -6 -11 -10 -2 -10 6 0 12 -9 12 -19 0 -11 4 -22 9 -25 5 -3 9 10 8 29 -1 38 -4 40 -27 25z" />
              <path d="M210 109 c0 -6 -7 -9 -15 -5 -16 6 -21 -9 -5 -19 5 -3 7 -12 4 -20 -4 -10 0 -12 15 -8 12 3 18 10 14 17 -4 6 -6 19 -5 29 2 9 1 17 -2 17 -3 0 -6 -5 -6 -11z" />
              <path d="M138 98 c-19 -7 -25 -14 -21 -26 5 -14 2 -14 -17 3 l-23 20 6 -25 c4 -14 7 -28 7 -32 0 -5 5 -8 11 -8 5 0 7 4 4 10 -3 5 -2 10 4 10 5 0 12 -4 15 -9 7 -10 56 -2 56 10 0 5 -8 9 -17 9 -15 0 -16 2 -3 10 13 9 13 10 0 10 -13 0 -13 1 0 10 22 14 9 19 -22 8z" />
            </g>
          </svg>
        </button>

        <button className="nav-job prev">
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="57.000000pt"
            height="61.000000pt"
            viewBox="0 0 57.000000 61.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0.000000,61.000000) scale(0.100000,-0.100000)"
              fill={props.fill}
              stroke="none"
            >
              <path d="M370 543 c0 -25 -1 -25 -19 -9 -15 14 -23 15 -44 5 -22 -10 -24 -15 -16 -37 5 -13 7 -27 4 -30 -3 -4 -8 4 -12 16 -4 15 -13 22 -30 22 -20 0 -24 -4 -18 -17 4 -10 10 -26 12 -35 3 -10 10 -18 15 -18 6 0 8 7 5 14 -5 11 1 14 23 11 16 -2 37 3 47 11 17 14 17 15 -4 9 -14 -4 -23 -2 -23 4 0 6 6 11 13 12 6 0 3 4 -8 9 -19 7 -19 8 -2 15 12 5 26 0 43 -15 l24 -23 0 41 c0 23 -2 42 -5 42 -3 0 -5 -12 -5 -27z m-100 -47 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z" />
              <path d="M185 473 c4 -10 10 -26 12 -35 3 -10 10 -18 15 -18 6 0 8 7 4 15 -3 8 -1 15 4 15 6 0 10 9 10 20 0 15 -7 20 -26 20 -21 0 -25 -3 -19 -17z m35 3 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z" />
              <path d="M82 453 c-23 -64 -55 -231 -54 -283 1 -95 9 -104 94 -119 145 -25 133 -26 157 8 18 25 20 34 11 52 -18 32 -8 42 69 74 72 31 81 40 95 106 6 28 -33 127 -58 148 -10 9 -36 1 -111 -34 -54 -25 -99 -44 -100 -43 -1 2 -18 29 -38 61 -20 31 -41 57 -46 57 -5 0 -13 -12 -19 -27z m64 -65 c15 -29 28 -55 30 -57 1 -2 18 6 36 17 48 29 159 73 169 66 9 -5 49 -78 49 -89 0 -3 -45 -26 -100 -51 -111 -52 -114 -57 -79 -125 11 -23 18 -43 15 -46 -3 -3 -29 2 -58 12 -29 9 -57 18 -63 20 -5 1 -23 7 -38 13 -16 7 -32 12 -36 12 -27 0 -29 29 -11 112 28 129 40 168 50 168 5 0 22 -24 36 -52z" />
            </g>
          </svg>
        </button>

        <div className="card">
          <img src={job3} alt="Sondos Baslouh" />
          <img src={job2} alt="Filelife Official" />
          <img src={job1} alt="Marão Burguer" />
        </div>
        <div className="card-body">
          <h3 className="text-white">Sondos Baslouh</h3>
          <h4>Front-end / Wordpress</h4>
          <a
            href="http://sondosbaslouh.com"
            title="Sondos Baslouh"
            target="_blank"
            rel="noopener noreferrer"
          >
            sondosbaslouh.com
          </a>
        </div>
        <div className="card-body">
          <h3 className="text-white">Filelife Official</h3>
          <h4>Front-end / Back-end Node</h4>
          <a
            href="https://filelife.co"
            title="Filelife Official"
            target="_blank"
            rel="noopener noreferrer"
          >
            filelife.co
          </a>
        </div>
        <div className="card-body">
          <h3 className="text-white">Marão Burgers Boston</h3>
          <h4>Front-end / Wordpress</h4>
          <a
            href="https://www.maraosburger.com"
            title="Marãos Burgers"
            target="_blank"
            rel="noopener noreferrer"
          >
            maraosburger.com
          </a>
        </div>

        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="376.000000pt"
          height="375.000000pt"
          viewBox="0 0 376.000000 375.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,375.000000) scale(0.100000,-0.100000)"
            fill={props.fill}
            stroke="none"
          >
            <path d="M565 3708 c-11 -6 -26 -18 -32 -26 -34 -42 5 -173 66 -225 49 -41 63 -35 39 18 -9 21 -8 36 5 79 24 76 22 131 -5 150 -26 19 -45 20 -73 4z m60 -118 c-4 -23 -9 -39 -12 -36 -3 2 -2 23 2 46 4 23 9 39 12 36 3 -2 2 -23 -2 -46z" />
            <path d="M344 3501 c-51 -13 -114 -53 -135 -88 -26 -42 -35 -128 -20 -190 7 -26 30 -87 52 -136 58 -129 61 -123 -82 -132 l-121 -7 7 -392 c4 -258 3 -428 -4 -501 -28 -276 -21 -1030 10 -1173 l11 -54 42 6 c22 3 66 8 97 12 l56 6 7 -45 c12 -76 67 -122 103 -86 9 9 16 2 29 -30 25 -63 69 -79 117 -41 14 11 28 33 32 49 6 27 8 28 35 18 22 -8 38 -8 64 1 26 10 40 10 60 1 21 -10 30 -9 53 6 26 17 27 17 38 0 33 -57 58 -76 94 -73 46 4 58 28 73 142 l11 86 137 0 138 0 93 -117 c121 -154 330 -361 449 -445 116 -82 303 -178 425 -217 177 -57 242 -66 455 -65 233 1 321 13 440 58 290 108 532 363 606 637 23 88 23 244 -1 328 -60 209 -293 402 -515 427 -107 12 -261 -44 -469 -169 -52 -32 -96 -55 -98 -53 -3 3 1 55 7 118 7 63 13 279 14 488 2 206 9 489 16 628 l14 253 58 30 c71 36 90 64 90 128 0 58 -26 108 -77 147 -31 24 -33 28 -37 100 -3 71 -6 78 -37 106 -27 24 -40 29 -73 26 -60 -4 -80 -36 -86 -138 -4 -63 -8 -80 -20 -80 -22 0 -94 -79 -88 -96 5 -12 -21 -13 -162 -8 -118 4 -272 0 -523 -15 -456 -27 -1049 -28 -1049 -2 0 8 55 98 85 140 31 43 32 72 1 108 -22 26 -30 28 -89 27 l-65 -1 0 66 c1 156 -115 248 -268 212z m151 -34 c38 -21 82 -80 95 -127 15 -57 8 -101 -32 -186 -28 -59 -33 -79 -32 -141 l1 -72 -71 5 c-120 8 -135 12 -150 42 -42 82 -90 232 -94 295 l-4 67 39 0 c32 0 46 -7 78 -40 21 -21 51 -42 67 -45 40 -9 91 10 116 44 l21 29 -22 10 c-14 7 -17 11 -7 11 16 1 22 53 8 67 -5 4 -8 2 -8 -4 0 -7 -7 -9 -17 -5 -12 5 -15 2 -10 -10 10 -27 -1 -19 -17 12 -8 15 -29 34 -46 41 -36 15 -61 7 -119 -39 -68 -52 -83 -49 -35 8 46 55 172 75 239 38z m-109 -38 c3 -6 1 -16 -5 -22 -8 -8 -11 -8 -11 1 0 19 -30 14 -31 -5 0 -12 -2 -13 -6 -5 -11 28 37 56 53 31z m54 -28 c13 -26 13 -31 -5 -31 -16 0 -38 34 -28 44 11 11 22 6 33 -13z m-140 -31 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m35 0 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m115 -27 c0 -9 -7 -25 -17 -35 -18 -20 -43 -24 -43 -7 0 5 5 7 11 3 7 -4 10 -1 7 7 -6 14 18 49 34 49 4 0 8 -8 8 -17z m-85 -13 c3 -5 -1 -10 -9 -10 -8 0 -18 5 -21 10 -3 6 1 10 9 10 8 0 18 -4 21 -10z m121 -19 c-12 -19 -24 -12 -19 10 4 13 9 17 15 11 6 -6 7 -15 4 -21z m2168 -44 l28 -12 -42 0 c-36 0 -47 -6 -72 -35 l-29 -35 12 33 c11 31 43 62 64 62 5 -1 23 -6 39 -13z m-3 -37 c12 -7 19 -21 18 -38 l-1 -27 -7 25 c-6 21 -12 24 -36 22 -17 -2 -31 -5 -31 -5 -1 -1 1 -17 3 -35 5 -28 9 -33 29 -30 27 3 36 -15 10 -20 -26 -5 -66 25 -66 51 0 33 22 57 58 66 2 1 12 -4 23 -9z m-1974 -77 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m1900 -40 c22 -17 88 -17 101 0 5 6 12 21 15 32 4 17 5 17 6 -3 0 -13 -6 -39 -15 -58 -18 -38 -95 -124 -111 -124 -9 0 -13 24 -29 180 -4 40 -3 42 6 15 5 -16 17 -36 27 -42z m-1879 -58 c0 -16 -2 -15 -8 5 -4 14 -8 34 -8 45 0 16 2 15 8 -5 4 -14 8 -34 8 -45z m19 23 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-58 -108 c1 -13 0 -13 -9 0 -5 8 -9 24 -9 35 l0 20 9 -20 c5 -11 9 -27 9 -35z m1676 -25 c88 -8 186 -15 217 -15 31 0 59 -4 63 -10 3 -5 -11 -28 -31 -50 l-37 -41 -186 3 c-102 2 -395 0 -651 -5 -395 -7 -493 -6 -660 8 -192 17 -482 16 -793 -1 l-107 -6 -35 38 c-19 21 -35 41 -35 45 0 4 38 13 85 20 70 10 111 10 218 -1 225 -22 940 -25 1273 -5 159 9 323 20 364 24 115 12 143 12 315 -4z m310 -546 c-9 -180 -15 -459 -14 -620 3 -356 -11 -525 -44 -551 -12 -10 -26 -18 -31 -18 -16 0 10 839 34 1125 6 61 10 178 10 261 0 161 12 252 38 297 17 28 17 27 20 -70 2 -54 -4 -245 -13 -424z m-2533 439 c23 -31 24 -38 17 -103 -4 -38 -16 -207 -25 -374 -19 -340 -16 -437 21 -861 13 -151 26 -332 27 -401 l3 -126 -37 -47 c-20 -27 -39 -53 -41 -59 -12 -33 -17 25 -29 306 -12 307 -4 686 22 1017 6 73 6 214 -1 383 -6 148 -8 275 -5 283 8 22 21 17 48 -18z m948 -28 c54 -5 400 -4 793 2 384 6 701 8 704 5 24 -25 26 -331 3 -552 -5 -50 -14 -277 -20 -505 -6 -228 -13 -451 -16 -495 l-6 -80 -121 -72 c-67 -40 -162 -91 -212 -115 l-90 -43 -225 1 c-287 1 -787 20 -910 34 -64 8 -206 9 -436 4 l-341 -6 -7 123 c-4 68 -16 237 -27 374 -27 337 -35 647 -20 815 6 74 16 218 21 319 6 102 13 187 16 190 9 9 478 19 644 14 85 -2 198 -8 250 -13z m2239 -1478 c49 -30 63 -52 34 -52 -24 0 -125 61 -131 79 -7 20 42 7 97 -27z m269 -311 c25 -52 27 -65 27 -181 0 -109 -3 -131 -23 -175 -25 -53 -78 -115 -99 -115 -18 0 -17 8 19 102 42 112 44 207 5 329 -15 47 -27 105 -27 130 l1 44 35 -39 c19 -22 47 -65 62 -95z m-2600 -51 c164 -15 652 -33 870 -34 100 0 182 -1 182 -2 0 -2 -30 -12 -67 -24 -43 -13 -82 -19 -112 -15 -25 2 -248 7 -496 10 -442 6 -675 0 -1060 -29 -93 -7 -172 -11 -174 -10 -6 5 49 85 62 89 13 5 403 21 570 23 60 1 161 -3 225 -8z m847 -105 c-93 -42 -342 -46 -425 -8 l-45 21 250 0 c218 0 246 -1 220 -13z m-911 -2 l38 -6 -4 -61 c-7 -76 -31 -128 -56 -119 -50 18 -82 75 -82 148 0 44 1 45 33 45 17 0 49 -3 71 -7z m-266 -12 c19 -12 28 -87 12 -106 -19 -22 -57 -18 -74 8 -17 27 -30 83 -21 97 7 12 65 13 83 1z m127 -3 c2 -7 6 -31 7 -52 3 -35 -1 -42 -25 -55 -27 -15 -29 -15 -48 8 -12 15 -19 38 -19 67 l0 44 40 0 c24 0 42 -5 45 -12z m-426 -9 c33 -12 41 -41 21 -80 -22 -40 -63 -8 -76 59 -7 36 2 39 55 21z m144 5 l47 -7 -2 -79 c-2 -67 -5 -82 -22 -94 -11 -8 -28 -14 -38 -14 -45 0 -78 87 -64 165 7 38 9 38 79 29z" />
            <path d="M240 3310 c0 -5 3 -10 8 -10 4 0 6 -33 4 -72 -4 -90 16 -134 71 -162 81 -39 156 8 178 112 7 31 16 61 21 67 4 5 8 20 8 32 l0 24 -45 -27 c-62 -36 -128 -31 -185 15 -40 32 -60 39 -60 21z m176 -91 c4 -8 9 -7 15 2 6 10 10 4 15 -19 5 -24 9 -30 15 -20 6 9 9 4 9 -15 0 -40 -49 -87 -90 -87 -53 0 -100 33 -100 70 0 5 14 25 31 45 24 27 39 35 64 35 19 0 37 -5 41 -11z" />
            <path d="M350 3204 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
            <path d="M380 3210 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z" />
            <path d="M405 3190 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z" />
            <path d="M852 799 c-12 -5 -22 -13 -22 -18 0 -16 20 -23 33 -12 7 5 23 8 35 4 17 -4 21 -2 16 10 -7 19 -34 26 -62 16z" />
            <path d="M580 775 c0 -9 5 -15 11 -13 6 2 11 8 11 13 0 5 -5 11 -11 13 -6 2 -11 -4 -11 -13z" />
            <path d="M620 781 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z" />
            <path d="M746 793 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z" />
            <path d="M705 780 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z" />
            <path d="M328 793 c-24 -6 -23 -23 2 -23 11 0 20 7 20 15 0 8 -1 14 -2 14 -2 -1 -11 -3 -20 -6z" />
            <path d="M430 778 c0 -8 15 -13 40 -13 31 -1 37 2 28 12 -14 17 -68 17 -68 1z" />
            <path d="M440 726 c0 -8 5 -18 10 -21 6 -3 10 1 10 9 0 8 -4 18 -10 21 -5 3 -10 -1 -10 -9z" />
            <path d="M480 725 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z" />
          </g>
        </svg>
      </div>

      <div className="aulas">
        <a
          href="https://www.youtube.com/watch?v=7tOpUzCPQU8"
          target="_blank"
          rel="noopener noreferrer"
          title="Watch my Youtube Videos doing speed coding"
        >
          <h2 className="text-white">Watch</h2>
          <p className="text-white">my Youtube Videos doing speed coding</p>
        </a>
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="208.000000pt"
          height="152.000000pt"
          viewBox="0 0 208.000000 152.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,152.000000) scale(0.100000,-0.100000)"
            fill={props.fill}
            stroke="none"
          >
            <path d="M1304 1486 c-197 -45 -271 -133 -521 -621 -175 -340 -192 -368 -328 -534 -127 -155 -200 -227 -290 -285 l-69 -46 756 0 756 0 79 58 c87 65 131 111 190 198 130 191 191 405 180 627 -15 303 -177 522 -437 593 -80 21 -242 27 -316 10z m116 -126 c23 -14 -30 -30 -101 -30 -43 0 -60 3 -57 12 8 24 127 38 158 18z m291 -95 c64 -33 101 -68 149 -141 57 -87 82 -157 82 -225 0 -55 -19 -112 -36 -106 -6 2 -19 44 -29 93 -27 132 -54 181 -153 272 -74 67 -124 126 -124 145 0 7 66 -15 111 -38z m-414 -107 c37 -40 31 -87 -15 -114 -27 -15 -26 -15 22 -10 27 4 58 6 69 6 18 0 17 2 -7 21 -32 25 -34 61 -5 90 21 21 59 20 86 -3 26 -22 9 -78 -27 -91 -8 -3 -2 -6 13 -6 20 -1 30 -7 34 -22 6 -20 6 -20 29 2 13 12 27 19 30 16 9 -9 25 -110 19 -116 -3 -2 -21 3 -41 12 -35 17 -35 17 -29 -2 7 -22 8 -22 -150 -41 -49 -7 -98 -14 -107 -16 -19 -5 -23 7 -33 84 l-7 52 39 1 c36 1 37 1 10 9 -44 13 -57 29 -57 70 0 69 82 106 127 58z" />
          </g>
        </svg>
      </div>
    </div>
  );
};
export default Portfolio;
